import { useEffect, useState } from "react";
import app from "nystem";

const CastLocation = ({ children, className = "", claim = true }) => {
  const [location, setLocation] = useState(app.uuid);
  const [state, setState] = useState({});

  useEffect(() => {
    if (!claim) return;
    let mounted = true;
    let revision = -1;
    let owns = false;
    let claimed = false;
    let timeout;
    const changed = (state) => {
      if (!mounted || state.revision === undefined || state.revision < revision) return;
      revision = state.revision;
      owns = state.location === location;
      clearTimeout(timeout);
      if (owns) timeout = setTimeout(() => setState({}), 30000);
      setState(state);
    };
    const request = async (action) => {
      const reply = await app.connection.emit({
        type: "playbackLocation",
        location,
        action,
        sessionid: app.session.user?.sessionid,
      });
      if (!mounted) return;
      if (reply.error) {
        owns = false;
        setState({ error: reply.error });
      } else if (reply.revision !== undefined) {
        claimed = true;
        changed(reply);
      }
    };
    const connected = ({ connected }) => {
      if (connected) {
        revision = -1;
        request(claimed ? "renew" : "claim");
      } else setState({});
    };
    app.connection.on("playbackLocation", changed);
    app.connection.on("connection", connected);
    request("claim");
    const interval = setInterval(() => {
      if (owns) request("renew");
    }, 10000);
    return () => {
      mounted = false;
      clearInterval(interval);
      clearTimeout(timeout);
      app.connection.off("playbackLocation", changed);
      app.connection.off("connection", connected);
      app.connection.emit({
        type: "playbackLocation",
        location,
        action: "release",
        sessionid: app.session.user?.sessionid,
      });
    };
  }, [location, claim]);

  if (!claim || state.location === location) return children;
  return (
    <div className={`bg-gray-950 p-8 text-center text-white ${className}`}>
      <p role="status" className="mb-3">
        {state.error || "Playing elsewhere"}
      </p>
      <button
        type="button"
        onClick={() => setLocation(app.uuid())}
        className="rounded-lg border border-white/15 bg-white/10 px-4 py-2 hover:bg-white/20"
      >
        Resume here
      </button>
    </div>
  );
};

export default CastLocation;
